import {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useState,
} from 'react'
import { ManufacturerApprovedDrawer } from './manufacturer-approved-drawer.component'

export interface ManufacturerApprovedDrawerContextProps {
  showManufacturerApprovedDrawer: boolean
  setShowManufacturerApprovedDrawer: Dispatch<SetStateAction<boolean>>
  nearestOemStoreName: string
  setNearestOemStoreName: Dispatch<SetStateAction<string>>
  nearestOemStoreDistance: number | undefined
  setNearestOemStoreDistance: Dispatch<SetStateAction<number | undefined>>
}

export const ManufacturerApprovedDrawerContext =
  createContext<ManufacturerApprovedDrawerContextProps>({
    showManufacturerApprovedDrawer: false,
    setShowManufacturerApprovedDrawer: () => null,
    nearestOemStoreName: '',
    setNearestOemStoreName: () => null,
    nearestOemStoreDistance: undefined,
    setNearestOemStoreDistance: () => null,
  })

export const useManufacturerApprovedDrawer = () =>
  useContext(ManufacturerApprovedDrawerContext)

interface ManufacturerApprovedDrawerProviderProps {
  children: React.ReactNode
}

const ManufacturerApprovedDrawerProvider: React.FC<
  ManufacturerApprovedDrawerProviderProps
> = ({ children }) => {
  const [showManufacturerApprovedDrawer, setShowManufacturerApprovedDrawer] =
    useState<boolean>(false)
  const [nearestOemStoreName, setNearestOemStoreName] = useState<string>('')
  const [nearestOemStoreDistance, setNearestOemStoreDistance] = useState<
    number | undefined
  >()
  return (
    <ManufacturerApprovedDrawerContext.Provider
      value={{
        showManufacturerApprovedDrawer,
        setShowManufacturerApprovedDrawer,
        nearestOemStoreName,
        setNearestOemStoreName,
        nearestOemStoreDistance,
        setNearestOemStoreDistance,
      }}
    >
      <ManufacturerApprovedDrawer />
      {children}
    </ManufacturerApprovedDrawerContext.Provider>
  )
}

export { ManufacturerApprovedDrawerProvider }
